import { SelectionAny } from './internal';
export class SelectionReference extends SelectionAny {
}
//# sourceMappingURL=SelectionReference.js.map